export const UNLIMITED_CHARACTERS = '-';
export const UNLIMITED_NUMBER = -1;
